/**
 * PCC's census action types, in the order the reports list them, and the
 * code of each one's colour in the report palette (`--c-<code>` in
 * @theme/styles/_report-palette.scss). Kept in sync with WorkflowServer's
 * PCC_ACTION_TYPES. Shared by the ADT report, the census action labels page
 * and the KPI pages.
 */
export const PCC_ACTION_TYPES = [
  'Admission',
  'Discharge',
  'Internal Transfer',
  'Leave',
  'Return from Leave',
  'Death',
  'Room Reserve',
] as const;

export type PccActionType = typeof PCC_ACTION_TYPES[number];

export const ACTION_TYPE_PALETTE_CODE: Readonly<Record<PccActionType, string>> = {
  Admission: 'adm',
  Discharge: 'dis',
  'Internal Transfer': 'it',
  Leave: 'lv',
  'Return from Leave': 'rl',
  Death: 'dth',
  'Room Reserve': 'rr',
};

/** The palette code for one action type; a type the palette has no colour for (or several joined) is 'other'. */
export function actionTypePaletteCode(actionType: string): string {
  const types: readonly string[] = PCC_ACTION_TYPES;
  const index = types.indexOf(actionType);
  return index === -1 ? 'other' : ACTION_TYPE_PALETTE_CODE[PCC_ACTION_TYPES[index]];
}
